import React from 'react';
import { BarChart3, Smartphone, TrendingUp } from 'lucide-react';
import web_image from '../../assets/stockkhata_dashboard_web.png';
import mob_image from '../../assets/stockkhata_dashboard_mob.jpg';
const DashboardShowcase = () => {
  return (
    <div style={{ all: 'unset', display: 'block', fontFamily: 'inherit' }}>
      <section className="py-20 bg-gradient-to-br from-white via-gray-50 to-slate-100 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-gradient-to-br from-black/5 to-gray-600/10 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-tl from-gray-600/10 to-black/5 rounded-full translate-x-1/2 translate-y-1/2"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold bg-gradient-to-r from-black to-gray-800 bg-clip-text text-transparent mb-6 tracking-tight">
            Powerful Analytics Dashboard
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Access your financial data and analytics on any device, anytime with our beautiful and intuitive interface
          </p>
        </div>

        {/* Device Showcase */}
        <div className="relative flex items-center justify-center mb-20">
          {/* Laptop Frame */}
          <div className="relative z-20">
            <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-t-3xl p-3 shadow-2xl ring-1 ring-slate-700/50">
              <div className="bg-black rounded-t-2xl overflow-hidden relative">
                {/* Laptop screen bezel */}
                <div className="absolute inset-x-0 top-0 h-8 bg-gradient-to-b from-slate-900 to-transparent flex items-center justify-center">
                  <div className="w-16 h-1 bg-slate-700 rounded-full"></div>
                </div>
                <img 
                  src={web_image} 
                  alt="StockKhata analytics dashboard on laptop" 
                  className="w-full h-auto object-cover rounded-t-xl"
                  style={{ width: '800px', height: '500px' }}
                />
              </div>
            </div>
            {/* Laptop base */}
            <div className="bg-gradient-to-b from-slate-800 to-slate-900 rounded-b-3xl h-8 relative">
              <div className="absolute inset-x-0 top-2 flex justify-center">
                <div className="w-24 h-2 bg-slate-700 rounded-full"></div>
              </div>
            </div>
          </div>

          {/* Mobile Frame */}
          <div className="absolute right-4 lg:right-20 top-20 z-30 transform rotate-12 hover:rotate-6 transition-transform duration-500">
            <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-3xl p-2 shadow-2xl ring-1 ring-slate-700/50">
              {/* Mobile notch */}
              <div className="relative bg-black rounded-3xl overflow-hidden">
                <div className="absolute inset-x-0 top-0 h-8 flex items-center justify-center">
                  <div className="w-20 h-4 bg-slate-900 rounded-b-2xl"></div>
                </div>
                <img 
                  src={mob_image}
                  alt="StockKhata mobile dashboard" 
                  className="w-full h-auto object-cover rounded-3xl"
                  style={{ width: '250px', height: '500px' }}
                />
              </div>
              {/* Home indicator */}
              <div className="absolute bottom-4 inset-x-0 flex justify-center">
                <div className="w-20 h-1 bg-slate-600 rounded-full"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Feature Callouts */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          <div className="text-center group">
            <div className="w-16 h-16 bg-gradient-to-br from-black to-gray-700 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110">
              <BarChart3 className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-black mb-3">Sector wise Data</h3>
            <p className="text-gray-600 leading-relaxed">
              Access comprehensive sector-wise analysis and performance metrics across all your portfolio holdings
            </p>
          </div>
          
          <div className="text-center group">
            <div className="w-16 h-16 bg-gradient-to-br from-black to-gray-700 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110">
              <Smartphone className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-black mb-3">Mobile Friendly</h3>
            <p className="text-gray-600 leading-relaxed">
              Fully optimized responsive design for smartphones and tablets with touch-friendly interactions
            </p>
          </div>
          
          <div className="text-center group">
            <div className="w-16 h-16 bg-gradient-to-br from-black to-gray-700 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110">
              <TrendingUp className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-black mb-3">Advanced Analytics</h3>
            <p className="text-gray-600 leading-relaxed">
              Visualize your investment data with interactive charts, graphs, and real-time performance insights
            </p>
          </div>
        </div>
      </div>
    </section>
    </div>
  );
};

export default DashboardShowcase;